import React, { useRef, useState, useEffect } from "react";
import { CustomerResourceProvider } from "@Local/CustomerResource/Components/CustomerResourceContext";
import { PageLayout } from "@Local/Components/Layout";
import { CustomerResourceSearchBar, CustomerResourceTable, CustomerResourceTabs } from "@Local/CustomerResource";
import useCustomerResourceApi from "@Apis/useCustomerResourceApi";

const CustomerResourcePage = () => {
	const addDialogRef = useRef(null);
	const refreshRef = useRef(null);
	const [customerResourceType, setCustomerResourceType] = useState(1);
	const [sourceData, setSourceData] = useState({
		list: [],
		pageIndex: 1,
		totalPage: 1,
		totalCount: 0,
	});
	const [bookmark, setBookmark] = useState({
		pageIndex: 1,
		pageSize: 20,
	});

	const { getCustomerResourceOverviewApi } = useCustomerResourceApi();

	const loadData = async () => {
        const response = await getCustomerResourceOverviewApi();
        setSourceData(response);
	};

	const setBookmarkNum = pageIndex => {
		setBookmark(prev => ({
			...prev,
			pageIndex,
		}));
	};

	const childContext = {
		customerResourceType,
		setCustomerResourceType,
		addDialogRef,
		sourceData,
		setSourceData,
		bookmark,
		setBookmarkNum,
		refresh: () => {
			loadData();
		},
		setRefresh: fn => (refreshRef.current = fn),
	};

	useEffect(
		() => {
			loadData();
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<CustomerResourceProvider value={childContext}>
			<PageLayout>
				<PageLayout.Header title="顧客來源總覽" />
				<CustomerResourceSearchBar />
				<CustomerResourceTabs />
				<CustomerResourceTable />
			</PageLayout>
		</CustomerResourceProvider>
	);
};

export default CustomerResourcePage;
